import { setNavigationSubTitle, setNavigationTitle } from '../../Store/features/navigationHeader/navigationHeaderSlice';
import { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import Avatar from '../Utility/Avatar';
import ChatInput from '../Chat/ChatInput/ChatInput';
import { ChatMessageRole } from '../../Types/Enums';
import usePromptState from '../../Hooks/state/usePromptState';
import { RootState, useAppDispatch, useAppSelector } from '../../store';

interface HomeProps {
    initMessage?: string;
}

function Home({ initMessage }: HomeProps) {
    const i18n = useAppSelector((state: RootState) => state.i18n.i18n);
    const dispatch = useAppDispatch();
    const location = useLocation();
    const { selectedPrompt } = usePromptState();
    useEffect(() => {
        dispatch(setNavigationSubTitle(''));
        dispatch(setNavigationTitle(''));
    }, [dispatch]);

    const chatInputComponent = useMemo(() => {
        return (
            <ChatInput
                key={`home-${location.pathname}-${selectedPrompt?.identifier ?? ''}`}
                giveExamples={true}
                initMessage={initMessage}
            />
        );
    }, [initMessage, location.pathname, selectedPrompt?.identifier]);

    return selectedPrompt ? (
        <div className="flex justify-center items-center h-full w-full">
            <div className="h-fit w-full max-w-[1280px] px-5 md:px-20 flex flex-col items-center">
                <div className="flex flex-col gap-3 items-center mb-3 relative">
                    <Avatar
                        role={ChatMessageRole.assistant}
                        avatarImage={selectedPrompt.image}
                        title={selectedPrompt.name}
                        size={50}
                        position="relative"
                    />
                    <p className="text-xl">{selectedPrompt.name}</p>
                </div>
                <h1 className="mb-5 text-center"> {i18n.translate({ id: 'start.headline' })} </h1>
                <div className="w-full sm:w-unset absolute sm:relative bottom-0 sm:bottom-unset max-w-[768px]">
                    {chatInputComponent}
                </div>
            </div>
        </div>
    ) : (
        <></>
    );
}

export default Home;
